export class TrafficBadge {
    badge: HTMLElement;

    constructor(badge: HTMLElement) {
        this.badge = badge;
        this.init();
    }

    init() {
        fetch(window.location.origin + '/api/count-traffic-entries?type=autobahnen&t' + Date.now())
            .then((response) => {
               return response.text();
            })
            .then((result) => {
                this.badge.classList.remove('d-none');
                // @ts-ignore
                this.badge.innerHTML = result;
            });
    }

}
document.addEventListener("DOMContentLoaded", function() {
    const badges: NodeListOf<HTMLElement> = document.querySelectorAll('[data-traffic-badge]');
    badges.forEach((badge: HTMLElement) => {
        new TrafficBadge(badge);
    });
});
